import {SystemStatusGroup} from "../../../gd/const/system-status"
import {TasksViewAppSettings} from "../core/@types"
import {SystemColumnType} from "../../manager/columns/types"
import {SettingsVersion} from "../../common/settings-manager"
import {CardViewLayout} from "../../../gd-ui/card-view-selector/card-view-selector"

export const TasksView_Table_DefaultAppSettings : TasksViewAppSettings = {
    version                 : SettingsVersion.VERSION_3,

    // columns                 : _.map(['2','12','4','3','6'], id=>({id: id/*, aggregate: null*/})),
    columns                 : [
        {
            id      : SystemColumnType.TITLE
        },
        {
            id      : SystemColumnType.ACTION_REQUIRED
        },
        {
            id      : SystemColumnType.SCHEDULE
        },
        {
            id      : SystemColumnType.PRIORITY
        },
        {
            id      : SystemColumnType.STATUS
        },
    ],
    systemStatusFilter      : SystemStatusGroup.ALL, // used is task table to show hide archived tasks
    sorting                 : null,  // current sorting value
    grouping                : null,  // current grouping value
    filters                 : {},
    areEmptyFoldersHidden   : false,
    areEmptyGroupsHidden    : true,
    areAddRowsHidden        : false,
    itemViewBorderPosition  : CardViewLayout.COLOR_CODING_NONE,
    colorTasksFieldId       : 'statusId',
    showSubTasks            : false,
}

// export default TasksView_Table_DefaultAppSettings